<template>
    <div class="spo-card rounded p-2 bordered my-3">
        <img :src="require(`@/assets/img/betrail_logo.png`)" class="betrail_logo mb-2" />
        <div><v-icon icon="mdi-information-variant" color="primary-dark"></v-icon> Ce parcours est limité aux coureurs
            possédant un <b>indice Betrail de 43 et plus</b>. Suivez ce <a href="https://www.betrail.run/"
                target="_blank">lien</a> afin de
            retrouver votre côte actuelle.</div>
        <label class="field_label">{{ current_champ.label }}<span class="text-red"
                v-if="current_champ.mandatory == 1">*</span></label>
        <v-text-field type="number" :required="current_champ.mandatory == 1" v-model="current_champ.value" ref="field"
            @blur="$refs.field.validate()" :disabled="current_champ.disabled || is_disable"
            placeholder="Votre indice Betrail (43 et plus)"
            :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-text-field>
    </div>
</template>

<script>
export default {
    props: ["champ", "inscription", "mode", "is_disable"],
    data() {
        return {
            current_champ: {},
        };
    },
    watch: {
        champ: {
            deep: true,
            handler() {
                this.current_champ = this.champ;
                this.$forceUpdate();
            },
        },
    },
    created() {
        this.current_champ = this.champ;
    },
};
</script>

<style lang="scss" scoped>
.betrail_logo {
    width: 100px;
    height: auto;
}
</style>